import * as React from "react"
import { InlineSvg, SvgWrapper } from "./styles"

export enum Glyphs {
  BurgerMenu = "burger-menu",
  Phone = "phone",
  Air = "air"
}

type Props = {
  glyph: string,
  size?: number | string,
  count?: string,
  onClick?: Function,
  onboarding?: string,
  dataCy?: string,
};


type GlyphProps = {
  glyph: string,
};

export const Glyph = ({ glyph }: GlyphProps) => {
  switch (glyph) {
    case Glyphs.BurgerMenu:
      return (
        <path d="M16.4,9H3.6C3.048,9,3,9.447,3,10c0,0.553,0.048,1,0.6,1h12.8c0.552,0,0.6-0.447,0.6-1S16.952,9,16.4,9z
         M16.4,13H3.6C3.048,13,3,13.447,3,14c0,0.553,0.048,1,0.6,1h12.8c0.552,0,0.6-0.447,0.6-1S16.952,13,16.4,13z M3.6,7h12.8
        C16.952,7,17,6.553,17,6s-0.048-1-0.6-1H3.6C3.048,5,3,5.447,3,6S3.048,7,3.6,7z"/>
      )
    case Glyphs.Phone:
      return (
        <path d="M11.229,11.229c-1.583,1.582-3.417,3.096-4.142,2.371c-1.037-1.037-1.677-1.941-3.965-0.102
        c-2.287,1.838-0.53,3.064,0.475,4.068c1.16,1.16,5.484,0.062,9.758-4.211c4.273-4.274,5.368-8.598,4.207-9.758
        c-1.005-1.006-2.225-2.762-4.063-0.475c-1.839,2.287-0.936,2.927,0.103,3.965C14.324,7.812,12.811,9.646,11.229,11.229z"/>
      )
    case Glyphs.Air:
      return (
        <path d="M2.643,6.357c1.747-1.5,3.127-2.686,6.872-0.57c1.799,1.016,3.25,1.4,4.457,1.398
         c2.115,0,3.486-1.176,4.671-2.193c0.423-0.363,0.477-1.008,0.122-1.439c-0.357-0.432-0.987-0.488-1.41-0.125
          c-1.746,1.502-3.127,2.688-6.872,0.57C5.535,1.205,3.217,3.195,1.355,4.795C0.933,5.158,0.879,5.801,1.234,6.234
          C1.59,6.664,2.22,6.721,2.643,6.357z M17.355,8.535c-1.746,1.5-3.127,2.688-6.872,0.57C5.535,6.31,3.217,8.301,1.355,9.9
          c-0.422,0.363-0.477,1.008-0.121,1.439c0.355,0.432,0.986,0.488,1.409,0.125C4.39,9.963,5.77,8.777,9.515,10.892
          c1.799,1.018,3.25,1.4,4.457,1.4c2.115,0,3.486-1.176,4.671-2.195c0.423-0.363,0.477-1.008,0.122-1.438
          C18.409,8.226,17.778,8.172,17.355,8.535z M17.355,13.641c-1.746,1.502-3.127,2.688-6.872,0.572
          c-4.948-2.795-7.266-0.805-9.128,0.795c-0.422,0.363-0.477,1.008-0.121,1.439c0.355,0.432,0.986,0.486,1.409,0.123
          C4.39,15.07,5.77,13.885,9.515,16c1.799,1.016,3.25,1.4,4.457,1.4c2.115,0,3.486-1.178,4.671-2.195
          c0.423-0.363,0.477-1.008,0.122-1.439C18.409,13.334,17.778,13.279,17.355,13.641z"/>
      )
  }
}

class Icon extends React.Component<Props> {
  render() {
    const {
      size = 32,
      onboarding,
      count,
      onClick,
      glyph,
      ...rest
    } = this.props

    return (
      <SvgWrapper
        size={size}
        onboarding={onboarding}
        count={count}
        className={"icon"}
        onClick={onClick}
        {...rest}
      >
        <InlineSvg
          fillRule="evenodd"
          clipRule="evenodd"
          strokeLinejoin="round"
          strokeMiterlimit="1.414"
          xmlns="http://www.w3.org/2000/svg"
          aria-labelledby="title"
          viewBox="0 0 20 20"
          preserveAspectRatio="xMidYMid meet"
          fit
        >
          <title id="title">{glyph}</title>
          <Glyph glyph={glyph}/>
        </InlineSvg>
      </SvgWrapper>
    )
  }
}

export default Icon
